(async () => {
  
    const modalReady = () => new Promise(resolve => {
      if (window.theme.modalReady) {
        resolve(); return;
      }
      document.addEventListener('modalReady', resolve, {
        once: true
      })
    });
  
    const baseComponent = await import(window.theme.modules.baseComponent);
  
    customElements.define('posted-popup', class extends baseComponent.default {
      
        async render() {
            if (new URLSearchParams(window.location.search).get('customer_posted') === 'true') {
                await modalReady();
                if (this.isConnected) this._trigerModal();
            } 
        };
  
        _trigerModal() {
            this.trigger('openPopup', {
              target: '#postedPopup',
              layout: 'small'
            })
        };
  
    });
})();